import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from "react-bootstrap/Modal";
import { AnchorComponent, ButtonComponent } from "../elements";
import { useNavigate, useLocation } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { SidebarContext } from "../../context/Sidebar";

import axios from "axios";

export default function DraftTableComponent({ thead, tbody, history }) {
	const { t } = useContext(TranslatorContext);
	const navigate = useNavigate();
	const location = useLocation();
	const { pathname, search } = useLocation();
	const pathnameroute = location.pathname;

	const [alertModal, setAlertModal] = useState(false);
	const [data, setData] = useState([]);
	const [searchQuery, setSearchQuery] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 100;
	const { hasPermission } = useContext(SidebarContext);
	useEffect(() => {
		setData(tbody);
	}, [tbody]);

	const handleSearch = (event) => {
		setSearchQuery(event.target.value.toLowerCase());
		setCurrentPage(1); // Reset to the first page when searching
	};

	const filteredData = data.filter((item) =>
		Object.values(item).some((val) =>
			String(val).toLowerCase().includes(searchQuery)
		)
	);

	const totalItems = filteredData.length;
	const totalPages = Math.ceil(totalItems / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const paginatedData = filteredData.slice(
		startIndex,
		startIndex + itemsPerPage
	);

	const handlePageChange = (page) => {
		if (page > 0 && page <= totalPages) {
			setCurrentPage(page);
		}
	};

	const navigateToEdit = (id) => {
		navigate(`/family-rescue-form/${id}`);
	};
	const navigateToVerify = (id) => {
		navigate(`/verify-family/${id}`);
	};
	// download pdf
	const downloadPdf = async (personId) => {
		const personData = await axios.get(
			process.env.REACT_APP_API_URL + `/family-finance-pdf/${personId}`
		);
		const win = window.open(personData.data.pdf, "_blank");
		if (win != null) {
			win.focus();
		}
	};
	return (
		<>
			<div className="mc-table-responsive">
				{/* Search Bar */}
				<div className="mc-search">
					<input
						type="text"
						placeholder={t("search")}
						value={searchQuery}
						onChange={handleSearch}
						className="form-control table-search"
					/>
				</div>

				{/* Table */}
				<table className="mc-table product">
					<thead
						className="mc-table-head "
						style={{ backgroundColor: "#077834", color: "#fff" }}
					>
						<tr>
							<th>
								<div className="mc-table-check">
									<p>FSF-ID</p>
								</div>
							</th>
							{thead.map((item, index) => (
								<th key={index}>{t(item)}</th>
							))}
						</tr>
					</thead>
					<tbody className="mc-table-body even">
						{paginatedData.map((item, index) => (
							<tr key={index}>
								<td title={index + 1}>
									<div className="mc-table-check">
										<p>{item.fsf_id}</p>
									</div>
								</td>
								<td>
									<div className="mc-table-product md">
										<div className="mc-table-group">
											<h6>
												<p>{item.beneficiary_name}</p>
												<p>{item.beneficiary_cnic}</p>
											</h6>
										</div>
									</div>
								</td>
								<td>
									<p>{item.partner_name}</p>
									<p>{item.organization_church}</p>
								</td>

								<td>
									<div className="mc-table-price">
										<p>{item.total_loan_amount}</p>
									</div>
								</td>
								<td>
									<div className="">
										<p>

											{item.assesment_date
												? new Date(item.assesment_date).toLocaleDateString()
												: ""}
										</p>
									</div>
								</td>
								<td>{item.status}</td>
								<td>
									<div className="mc-table-action">
										<AnchorComponent
											to={`/family-report/${item.fsf_id}`}
											title="View"
											className="material-icons view"
											style={{
												color: "#fff",
												backgroundColor:
													"rgba(7, 120, 52, 0.7)",
												borderRadius: "5px",
												padding: "5px",
											}}
										>
											{item.action.view}
										</AnchorComponent>
										{hasPermission("CanEditDraft") && (
											<AnchorComponent
												to="#!"
												title="Edit"
												onClick={() =>
													navigateToEdit(item.id)
												}
												className="material-icons edit"
												style={{
													color: "#fff",
													backgroundColor:
														"rgba(7, 120, 52, 0.7)",
													borderRadius: "5px",
													padding: "5px",
												}}
											>
												{item.action.edit}
											</AnchorComponent>
										)}
										<ButtonComponent
											type="button"
											title="Download Invoice"
											className="material-icons edit"
											onClick={() => downloadPdf(item.id)}
											style={{
												color: "#fff",
												backgroundColor:
													"rgba(7, 120, 52, 0.7)",
												borderRadius: "5px",
												padding: "5px",
											}}
										>
											<DownloadIcon fontSize="small" />
										</ButtonComponent>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			{/* Pagination */}
			<div className="mc-paginate">
				<p className="mc-paginate-title">
					{t("showing")}
					<b> {startIndex + 1} </b>
					{t("to")}
					<b> {Math.min(startIndex + itemsPerPage, totalItems)} </b>
					{t("of")}
					<b> {totalItems} </b>
					{t("results")}
				</p>
				<ul className="mc-paginate-list">
					<li
						style={{
							color: "#077834",
							backgroundColor: "#e8f5e9", // default background
							borderRadius: "4px",
							padding: "5px 10px",
							cursor: "pointer",
							transition: "all 0.3s ease",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = "#077834";
							e.currentTarget.style.color = "#fff";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = "#e8f5e9";
							e.currentTarget.style.color = "#077834";
						}}
						onClick={() => handlePageChange(currentPage - 1)}
					>
						<i className="material-icons">chevron_left</i>
					</li>

					{[...Array(totalPages)].map((_, index) => {
						const isActive = index + 1 === currentPage;
						return (
							<li
								key={index}
								className="mc-paginate-item"
								style={{
									backgroundColor: isActive
										? "#077834"
										: "#e8f5e9",
									color: isActive ? "#fff" : "#077834",
									borderRadius: "4px",
									padding: "5px 10px",
									margin: "0 4px",
									cursor: "pointer",
									transition: "background-color 0.3s ease",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor =
										"#06622a";
									e.currentTarget.style.color = "#fff";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor =
										isActive ? "#077834" : "#e8f5e9";
									e.currentTarget.style.color = isActive
										? "#fff"
										: "#077834";
								}}
								onClick={() => handlePageChange(index + 1)}
							>
								{index + 1}
							</li>
						);
					})}
					<li
						style={{
							color: "#077834",
							backgroundColor: "#e8f5e9",
							borderRadius: "4px",
							padding: "5px 10px",
							cursor: "pointer",
							transition: "all 0.3s ease",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = "#077834";
							e.currentTarget.style.color = "#fff";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = "#e8f5e9";
							e.currentTarget.style.color = "#077834";
						}}
						onClick={() => handlePageChange(currentPage + 1)}
					>
						<i className="material-icons">chevron_right</i>
					</li>
				</ul>
			</div>

			{/* Alert Modal */}
			<Modal
				show={alertModal}
				onHide={() => setAlertModal(false)}
			>
				<div className="mc-alert-modal">
					<i className="material-icons">new_releases</i>
					<h3>Are you sure?</h3>
					<p>Want to delete this product?</p>
					<Modal.Footer>
						<ButtonComponent
							type="button"
							className="btn btn-secondary"
							onClick={() => setAlertModal(false)}
						>
							{t("close")}
						</ButtonComponent>
						<ButtonComponent
							type="button"
							className="btn btn-danger"
							onClick={() => setAlertModal(false)}
						>
							{t("delete")}
						</ButtonComponent>
					</Modal.Footer>
				</div>
			</Modal>
		</>
	);
}
